// extracted by mini-css-extract-plugin
module.exports = {"numberButton":"MobilePagination_numberButton__pP3Jq","numberButtonSelected":"MobilePagination_numberButtonSelected__nwEpE"};